import { css } from "@emotion/css";
import { ExternalLink, PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { TemplateExpressionIllustration } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDHelmAnnotationsDrawer/TemplateExpressionIllustration";
const styles = {
    container: css({
        display: "flex",
        flexDirection: "column",
        gap: space[16],
    }),
    title: css({
        margin: 0,
        marginBottom: space[8],
        font: text.body.bold.large,
    }),
};
export const ImageTemplateExpressionHelp = () => (<PopoverBasicHelp description={<div className={styles.container}>
                <TemplateExpressionIllustration />
                <div>
                    <p className={styles.title}>Image template expression</p>
                    <div>
                        Look for the image template expression in your Helm chart. <br />
                        <br />
                        Locate the <code>image</code> field under a container definition. Copy and paste the full expression to generate an annotation.
                        <br />
                        <br />
                        <strong>Don’t have access to the Helm chart?</strong>
                        <br />
                        <ExternalLink label={"Read the docs"} href={"argo-cd-helm-image-annotations"}/> to create the template expression from the values file.
                    </div>
                </div>
            </div>} placement={"left-start"}/>);
